import { Container, ContainerGutter, ContainerPadding, styled, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { oneformBFFNdpsSend } from 'src/bff';
import { Apellido, Error, LastNavigation, LegalesFormatoLayer, Loading, Nombre, PoliticaPrivacidad, Telefono } from 'src/components';
import { formatPrefix, FormController, useFeatureServices, useGetInstalaciones, useOneFormContext } from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { LayoutWrapper } from 'src/feature-app/Screen';
import { EsOneformCoreServiceV1 } from 'src/feature-service/es-oneform-core-feature-service/types';
import { createPincodeEntity } from 'src/forms/dps-utils';
import { formatFlags, formatHeaders, formDataBuilder } from 'src/forms/format-fields';
import { FormDataGroup, FormInfo, IdLead, IdPerson, OneFormState, Steps } from 'src/types';
import { GTI50LeadThankYou } from '.';

const FormStyled = styled.div`
	& {
		background-color: #000000 !important;
		background-image: url('https://assets.volkswagen.com/is/image/volkswagenag/textura-negra2?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD13ZWJwJnFsdD03OSZiZmM9b2ZmJmJmMTc=');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
	span,
	p,
	input,
	select,
	div {
		color: #ffffff !important;
	}
	button {
		background-color: #000000 !important;
		color: #ffffff !important;
		border: 1px solid #ffffff !important;
	}
	button:hover,
	button:focus,
	button:active {
		background-color: #c90010 !important;
		color: #ffffff !important;
		border: 1px solid #c90010 !important;
	}
	button:focus-visible {
		outline: none !important;
	}
	button[aria-label*='aceptar'],
	button[type*='submit'] {
		background-color: #c90010 !important;
		color: #ffffff !important;
		border: 1px solid #c90010 !important;

		&:hover {
			background-color: #a5000d !important;
			border: 1px solid #a5000d !important;
		}
	}
	label:hover {
		box-shadow: #c90010 0 0 0 1px !important;
	}
	label:focus-within {
		box-shadow: #c90010 0 0 0 2px !important;
	}
	label:focus-visible {
		outline: none;
	}
	/* MAPA */
	ul {
		background: #000000 !important;
		border: 1px solid #ffffff !important;
	}
	ul svg,
	ul svg:hover {
		fill: #ffffff !important;
	}
	.styled-wrapper-suggest {
		box-shadow: #ffffff 0px 0px 0px 1px !important;
	}

	/* Fix no existe previus step en el primer step en desktop. Añadimos width al div que corresponde previus step para centrar fields del primer step. */
	@media screen and (min-width: 960px) {
		.form-controller-wrapper .full-screen > div:nth-of-type(2) {
			min-width: 1px;
			height: 0;
		}
	}
`;

const bodyStyled = () => {
	if (document.getElementById('oneform-gti50-style')) return;

	const css = /*css*/ `
		/* HEADER */
		header {
			background: linear-gradient(180deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%) !important;
		}
		header svg {
			fill: #ffffff !important;
		}
		header > div:nth-of-type(2) > span::before,
		header > div:nth-of-type(2) > span::after {
			background: #ffffff !important;
		}
		div[data-cy='menuLabel'] {
			color: #ffffff !important;
		}

		/* SCREEN */
		main,
		.screen-controller {
			background-color: #000000 !important;
			background-image: url('https://assets.volkswagen.com/is/image/volkswagenag/textura-negra2?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD13ZWJwJnFsdD03OSZiZmM9b2ZmJmJmMTc=');
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
		}
		div[data-cy='NextBestActionV2'] {
			display: none;
		}
		main > div > div {
			padding-top: var(--s2-one-hub-navigation-top-bar-height) !important;
		}

		/* NAVIGATION PROGRESS */
		.navigation-wrapper > div > div {
			background-color: #000000 !important;
			color: #ffffff !important;
		}
		.navigation-wrapper * {
			color: #ffffff !important;
		}
		.navigation-wrapper button {
			background-color: #c90010 !important;
			margin-top: 10px;
			margin-bottom: -10px;
		}
		.navigation-wrapper button:hover {
			background-color: #a5000d !important;
		}
		.navigation-wrapper button svg {
			fill: #ffffff !important;
		}
		.navigation-wrapper .display-wrapper > div:nth-of-type(1) > div:nth-of-type(1) > div:nth-of-type(1) {
			background: #aaaaaa !important;
		}
		.navigation-wrapper .display-wrapper > div:nth-of-type(1) > div:nth-of-type(1) > div:nth-of-type(2) {
			background: #ffffff !important;
		}
		.content-wrapper > div:nth-child(2) > div > div:nth-child(3) div {
			background: #000000 !important;
		}

		/* THANK YOU */
		.thank-you-wrapper button {
			background-color: #c90010 !important;
			color: #ffffff !important;
			border: 1px solid #c90010 !important;
		}
		.thank-you-wrapper button:hover,
		.thank-you-wrapper button:focus,
		.thank-you-wrapper button:active {
			background-color: #a5000d !important;
			border: 1px solid #a5000d !important;
		}

		/* MAP */
		.lead-inPage-MAP-controller .wrapper,
		.lead-inPage-MAP-controller .close-wrapper {
			background: #000000 !important;
		}
		.lead-inPage-MAP-controller button:hover,
		.lead-inPage-MAP-controller button:focus,
		.lead-inPage-MAP-controller button:active {
			background-color: #c90010 !important;
			color: #ffffff !important;
			border: 2px solid #c90010 !important;
		}
		.lead-inPage-MAP-controller .box-card-wrapper:hover {
			border: 2px solid #c90010 !important;
		}
		.lead-inPage-MAP-controller .box-card-wrapper {
			background-color: #000000 !important;
		}
	`;

	const style = document.createElement('style');
	style.id = 'oneform-gti50-style';
	style.innerHTML = css;
	document.head.appendChild(style);
};

const InputsWrapper = styled.div`
	padding-top: 44px;
	gap: 24px;
	display: flex;
	flex-direction: column;
	width: 100%;
	@media screen and (min-width: 960px) {
		display: flex;
		justify-content: flex-start;
		flex-direction: row;
		flex-wrap: wrap;
		margin-top: 0;
	}
`;

const LastNavigationWrapper = styled.div`
	& div {
		justify-content: left;
	}
`;

export function GTI50LeadFormTelefono() {
	const { initializeForm } = useOneFormContext();
	const store = useStore();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	const { formData }: OneFormState = store.getState();
	const { fields } = formData;

	const selectedInstallationRef = useRef(null);
	const { installations, loading: loadingInstallations, error: errorInstallations } = useGetInstalaciones('VW_DDB_FRM_LEM_REC_LEM', 'VOLKSWAGEN_SF_LEAD_INSTALLATION_VN_VO_SERVICE', 'vn');

	const oneFormService = useFeatureServices()['es:oneform-core'] as EsOneformCoreServiceV1;
	const dpsData = oneFormService.getDpsData();

	const idLead = createPincodeEntity(dpsData, 'LEAD') as IdLead;
	const idPerson = createPincodeEntity(dpsData, 'PERSON') as IdPerson;

	useEffect(() => {
		if (dpsData.pincode.pincodeError || dpsData.pincode.noPincodeFound) {
			setLoading(false);
			setError(true);
		} else if (idLead && installations) {
			setLoading(false);
			const installation = installations.find((d) => d.Id == idLead.Dealership__c);
			selectedInstallationRef.current = installation;
			if (!installation) {
				setError(true);
			}
		}
		if (!fields.name) {
			dispatch({ type: 'UPDATE_FIELDS', payload: { name: idLead?.FirstName ? idLead?.FirstName : idPerson?.FirstName } });
		}
		if (!fields.surname) {
			dispatch({ type: 'UPDATE_FIELDS', payload: { surname: idLead?.LastName ? idLead?.LastName : idPerson?.LastName } });
		}
	}, [dpsData, idLead, installations]);

	let index = 0;
	const steps: Steps[] = [
		{
			title: <></>,
			fields: (
				<LayoutWrapper>
					<Text appearance={TokenTextAppearance.headline300}>
						<Text bold>¿Cómo nos ponemos </Text>en contacto contigo?
					</Text>
					<InputsWrapper>
						<>
							<Nombre setFieldValue />
							<Apellido name="surname" label="Primer apellido" required setFieldValue />
						</>
						<Telefono required paginaConfirmacion={true} />
					</InputsWrapper>

					<Container padding={{ top: ContainerPadding.static350 }}>
						<PoliticaPrivacidad />
					</Container>
					<LastNavigationWrapper>
						<LastNavigation loadingCopy="Enviando tu petición" />
					</LastNavigationWrapper>
					<Container padding={{ top: ContainerPadding.static550, bottom: ContainerPadding.static515 }} gutter={ContainerGutter.static300} wrap={'always'}>
						<Text bold staticSize appearance={TokenTextAppearance.copy200}>
							Texto legal de Volkswagen
						</Text>
						<LegalesFormatoLayer noPadding={true} />
					</Container>
				</LayoutWrapper>
			),
			screenIndex: index++,
			name: 'contacto',
			outputs: ['cellphone'],
			outputsText: ['cellphone'],
		},
	];

	const sendForm = (): Promise<boolean> => {
		return new Promise<any>(async (resolve, reject) => {
			const { tc, today, url, device } = getParamsForm();
			const { formData }: OneFormState = store.getState();
			const { fields, headers, flags } = formData;
			const installation = selectedInstallationRef.current;

			const data = {
				'fields[PERSON_PHONE_MOBILE_FULL]': `${formatPrefix(fields.prefix)}${fields.cellphone}`,
				'fields[PERSON_PHONE_MOBILE]': fields.cellphone,
				'fields[PERSON_PHONE_PREFIX]': formatPrefix(fields.prefix),
				'fields[PERSON_NAME]': fields.name,
				'fields[PERSON_SURNAME_1]': fields.surname,

				...formatHeaders(headers),
				'headers[ORIGIN_DEVICE_TYPE]': device,
				'headers[ORIGIN_TRACKING_CODE]': tc,
				'headers[FORM_URL]': url,
				'headers[FORM_DATE_INSERTION]': today,
				'headers[FORM_NAME]': `vw-oneform-${fields.formName}`,
				'headers[FORM_VERSION]': `vw-oneform-${fields.formName}-${process.env.VERSION}`,
				...formatFlags(flags),
				'fields[DPS_BRAND]': 'Volkswagen',
				'fields[SF_LEAD_RECORDTYPE_NAME]': 'Sales Assistant',
				'fields[SF_LEAD_RECORDTYPE_ID]': '0121i000000D7NyAAK',
				'fields[SF_LEAD_SALES_INITIAL_ACTION]': 'Direct to Sales Assistant',
				'fields[SF_LEAD_INSTALLATION_ADDRESS]': installation?.ShippingStreet,
				'fields[SF_LEAD_INSTALLATION_CODE]': installation?.VGED_DealerCode__c,
				'fields[SF_LEAD_INSTALLATION_ID]': installation?.Id,
				'fields[SF_LEAD_INSTALLATION_NAME]': installation?.VGED_CommercialName__c,
				'fields[SF_LEAD_INSTALLATION_PROVINCE_CODE]': installation?.ShippingStateCode?.toString().padStart(2, '0'),
				'fields[PERSON_SURNAME_2]': idLead.MiddleName ? idLead.MiddleName : idPerson.MiddleName,
				'fields[PERSON_EMAIL]': idLead.Email ? idLead.Email : idPerson.PersonEmail,
				'fields[PERSON_RGPD_COM_COMERCIALES]': idLead.VGED_CommercialPermits__c,
				'fields[PERSON_RGPD_PERFILADO]': idLead.VGED_Profiling__c,
				// faContent hardcoded
				'headers[FORM_WEB_SECTION]': 'Golf GTI 50 Aniversario',
				'fields[VEH_INTEREST_ID]': '30602',
				'fields[VEH_INTEREST_MODEL]': 'Golf',
				'fields[VEH_INTEREST_FUEL]': 'Combustion',
				'fields[VEH_INTEREST_NEW_OR_USED]': 'New Car',
				'fields[VEH_INTEREST_SALESGROUP]': 'Golf GTI',
				'fields[VEH_INTEREST_SALESGROUP_ID]': '35272',
				'fields[VEH_INTEREST_TRIM_LINE]': 'GTI',
				'fields[VEH_INTEREST_DETAILS]': 'Edición 50 Aniversario',
			};

			const dataStringified = JSON.stringify(data);
			const dataParsed = JSON.parse(dataStringified);
			const formDataInfo = formDataBuilder(dataParsed);
			const response = await oneformBFFNdpsSend(formDataInfo);

			if (response?.data?.status?.code == 200) {
				dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
				resolve(true);
			} else {
				resolve(false);
			}
		});
	};

	const getFormInfo = (): {
		firstStep: Steps;
		lastStep: Steps;
		stepsHistory: number[];
		numberOfScreens: number;
	} => {
		return {
			firstStep: steps[0],
			lastStep: steps[steps.length - 1],
			stepsHistory: [0],
			numberOfScreens: steps.length,
		};
	};

	const initialFormData: Partial<FormDataGroup> = {
		headers: {
			DPS_TOKEN: 'VW_DDB_FRM_LEM_REC_LEM',
			FORM_OBJECTIVE: 'Más Información',
			SF_CAMPAIGN_ID: '7011n000000JrSNAA0',
		},
		flags: {
			PERSON_RGPD_ADAPTED: 'true',
			FLAG_IS_MYSTERY_LEAD: 'false',
			FLAG_RELACION_MARCA_SIN_IC: 'false',
			FLAG_SF_INTEGRATION: 'true',
			FLAG_ALLOWS_DATA_ENRICHMENT: 'false',
		},
		fields: {
			formularioFlag: 'masInformacion',
			formName: 'adhoc-2025-gti50_leads_telefono',
			formType: 'contact',
			pageCategory: 'Más Información',
		}, // Analítica
	};

	const { firstStep, lastStep, stepsHistory, numberOfScreens } = getFormInfo();

	const formInfoConfig: Partial<FormInfo> = {
		formStarted: true,
		sendFormCallback: sendForm,
		fullScreen: false,
		lastStep,
		numberOfScreens,
		notALayer: false,
		formTheme: 'inverted',
		formType: 'inPage',
		screenIndex: steps[0].screenIndex,
		step: firstStep,
		steps,
		stepsHistory,
		thankYouComponent: <GTI50LeadThankYou />,
		hideLegal: true,
	};

	useEffect(() => {
		initializeForm(formInfoConfig, initialFormData);
	}, []);

	useEffect(() => {
		bodyStyled();
	});

	return error || errorInstallations ? (
		<FormStyled>
			<Error />
		</FormStyled>
	) : loading || loadingInstallations ? (
		<Loading />
	) : (
		<FormStyled>
			<FormController steps={steps} screenType={'full-screen'} />
		</FormStyled>
	);
}
